/**
 * Converia.Core.module
 *
 * Converia.SiteStructure.Article
 */
Converia.Core.module('Converia.SiteStructure.Article', function () {
    /**
     * Article
     * 
     * @param rawArticleJson
     * @constructor
     */
    var Article = function (rawArticleJson) {
        this.id = rawArticleJson.id;
        this.shownName = rawArticleJson.shownName;
    };

    /**
     * Article.prototype.toJson
     * 
     * @returns {{id: *, shownName: *}}
     */
    Article.prototype.toJson = function () {
        return {
            id: this.id,
            shownName: this.shownName
        };
    };

    /**
     * Article.prototype.getId
     * 
     * @returns {int}
     */
    Article.prototype.getId = function () {
        return this.id;
    };

    /**
     * Article.prototype.getShownName
     * 
     * @returns {string}
     */
    Article.prototype.getShownName = function () {
        return this.shownName;
    };

    return Article;
});